// SO&RO Kortingsbadges — automatisch gegenereerd op 2026-07-27
// Alleen producten uit Festival Favorites (-30%), Chique Choices (-25%) of Sale Stars (-50%)
(function() {
  var BADGES = {
  15803798028661: { label: "-50%", color: "#e63946" },
  15933125165429: { label: "-50%", color: "#e63946" },
  15933124641141: { label: "-50%", color: "#e63946" },
  15933084205429: { label: "-50%", color: "#e63946" },
  15933079585141: { label: "-50%", color: "#e63946" },
  15933078929781: { label: "-50%", color: "#e63946" },
  15932956934517: { label: "-50%", color: "#e63946" },
  15932956246389: { label: "-50%", color: "#e63946" },
  15932955591029: { label: "-50%", color: "#e63946" },
  15924028408181: { label: "-50%", color: "#e63946" },
  15879365001589: { label: "-50%", color: "#e63946" },
  15851011703157: { label: "-50%", color: "#e63946" },
  15834908590453: { label: "-50%", color: "#e63946" },
  15834903904629: { label: "-50%", color: "#e63946" },
  15835457192309: { label: "-25%", color: "#b8965a" },
  15879388692853: { label: "-25%", color: "#b8965a" },
  15850276454773: { label: "-25%", color: "#b8965a" },
  15879389118837: { label: "-25%", color: "#b8965a" },
  15879388954997: { label: "-25%", color: "#b8965a" },
  15835457388917: { label: "-25%", color: "#b8965a" },
  15834922844533: { label: "-25%", color: "#b8965a" },
  15924029686133: { label: "-25%", color: "#b8965a" },
  15879388889461: { label: "-25%", color: "#b8965a" },
  15879388791157: { label: "-25%", color: "#b8965a" },
  15844836901237: { label: "-25%", color: "#b8965a" },
  15836135227765: { label: "-25%", color: "#b8965a" },
  15835457454453: { label: "-25%", color: "#b8965a" },
  15835457421685: { label: "-25%", color: "#b8965a" },
  15816416100725: { label: "-30%", color: "#1a1a1a" },
  15815974551925: { label: "-30%", color: "#1a1a1a" },
  15919119237493: { label: "-30%", color: "#1a1a1a" },
  15919119368565: { label: "-30%", color: "#1a1a1a" },
  15926178152821: { label: "-30%", color: "#1a1a1a" },
  15926178185589: { label: "-30%", color: "#1a1a1a" },
  15926178120053: { label: "-30%", color: "#1a1a1a" },
  15924028113269: { label: "-30%", color: "#1a1a1a" },
  15924028178805: { label: "-30%", color: "#1a1a1a" },
  15924028211573: { label: "-30%", color: "#1a1a1a" }
  };

  var STYLE = `
    .soandro-badge {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 3px 8px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.06em;
      color: #fff;
      border-radius: 2px;
      z-index: 10;
      pointer-events: none;
      font-family: 'Archivo', sans-serif;
    }
  `;

  function injectStyle() {
    if (document.getElementById('soandro-badge-style')) return;
    var s = document.createElement('style');
    s.id = 'soandro-badge-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function applyBadges() {
    injectStyle();
    // Verwijder eerst alle bestaande badges (voorkomt duplicaten)
    document.querySelectorAll('.soandro-badge').forEach(function(el) { el.remove(); });

    // Alleen product-card custom elements (collectiepagina's) — NIET product-price of andere elementen
    // Dit voorkomt dat badges op productpagina's meerdere keren verschijnen
    var cards = document.querySelectorAll('product-card');
    
    // Fallback voor themes die geen product-card custom element gebruiken
    if (cards.length === 0) {
      cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper, .grid__item[class*="product"]');
    }

    cards.forEach(function(card) {
      var pid = null;

      // Zoek product-id via data-attribuut op de card zelf of child elements
      // Maar NIET via product-price (die heeft ook data-product-id maar is geen kaartje)
      var priceEl = card.querySelector('product-price');
      if (priceEl && priceEl.hasAttribute('data-product-id')) {
        pid = parseInt(priceEl.getAttribute('data-product-id'));
      }
      
      if (!pid) {
        var el = card.querySelector('[data-product-id]:not(product-price)');
        if (el) pid = parseInt(el.getAttribute('data-product-id'));
      }

      if (!pid || !BADGES[pid]) return;

      var badge = BADGES[pid];

      // Zoek de afbeelding container — alleen binnen de card, niet op productpagina
      var imgWrap = card.querySelector('.card__media, .card-media, .product-card__image, .product__media, figure, .media');
      if (!imgWrap) {
        // Zoek de eerste img of link als fallback
        var firstLink = card.querySelector('a');
        if (firstLink) imgWrap = firstLink;
        else imgWrap = card;
      }

      // Controleer of er al een badge is in deze specifieke container
      if (imgWrap.querySelector('.soandro-badge')) return;

      // Zorg dat de container relatief gepositioneerd is
      var pos = window.getComputedStyle(imgWrap).position;
      if (pos === 'static') imgWrap.style.position = 'relative';

      var span = document.createElement('span');
      span.className = 'soandro-badge';
      span.textContent = badge.label;
      span.style.backgroundColor = badge.color;
      imgWrap.insertBefore(span, imgWrap.firstChild);
    });
  }

  // Run bij DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBadges);
  } else {
    applyBadges();
  }

  // Run ook na dynamische content (infinite scroll, filters)
  var observer = new MutationObserver(function(mutations) {
    var hasNewCards = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          n.matches && (n.matches('product-card') || n.matches('.card-wrapper') || n.matches('.grid__item'))
          || (n.querySelector && (n.querySelector('product-card') || n.querySelector('.card-wrapper')))
        );
      });
    });
    if (hasNewCards) applyBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
